import React, { useCallback, useEffect, useRef, useState } from "react";
import { PeekBox, PeekButton, PeekCircularProgress, PeekIconButton, PeekTooltip, useTheme, } from "@piiqtechnologies/ui-components";
import { Trash2 } from "@piiqtechnologies/svg-icons";
const CONFIRM_TIMEOUT_MS = 3000;
export const InlineDeleteButton = ({ tooltip, confirmLabel, onConfirm, deleted, error }) => {
    const theme = useTheme();
    const [state, setState] = useState("idle");
    const confirmTimeoutRef = useRef();
    const handleClick = useCallback((e) => {
        e.stopPropagation();
        if (state === "idle") {
            setState("confirming");
            confirmTimeoutRef.current = setTimeout(() => setState("idle"), CONFIRM_TIMEOUT_MS);
        }
        else if (state === "confirming") {
            clearTimeout(confirmTimeoutRef.current);
            setState("deleting");
            onConfirm();
        }
    }, [state, onConfirm]);
    useEffect(() => {
        return () => clearTimeout(confirmTimeoutRef.current);
    }, []);
    useEffect(() => {
        if (error) {
            setState("idle");
        }
    }, [error]);
    useEffect(() => {
        if (deleted) {
            setState("idle");
        }
    }, [deleted]);
    if (state === "idle") {
        return (React.createElement(PeekTooltip, { title: tooltip },
            React.createElement(PeekIconButton, { onClick: handleClick, bordered: false, "aria-label": tooltip },
                React.createElement(Trash2, { fontSize: 16 }))));
    }
    if (state === "deleting") {
        return React.createElement(PeekCircularProgress, { size: 16, sx: { color: "teal" } });
    }
    return (React.createElement(PeekButton, { onClick: handleClick, variant: "contained", size: "small", disableRipple: true, sx: {
            textTransform: "none",
            whiteSpace: "nowrap",
            position: "relative",
            overflow: "hidden",
            color: theme.palette.error.main,
            backgroundColor: "#fff",
            border: `1px solid ${theme.palette.error.main}`,
            boxShadow: "none",
            "&:hover": {
                backgroundColor: "#fff",
                boxShadow: "none",
            },
        } },
        React.createElement(PeekBox, { component: "span", sx: { position: "relative", zIndex: 2 } }, confirmLabel),
        React.createElement(PeekBox, { component: "span", "aria-hidden": "true", sx: {
                position: "absolute",
                inset: 0,
                zIndex: 3,
                pointerEvents: "none",
                clipPath: "inset(0 0 0 0)",
                animation: "confirmClip 3s linear forwards",
                "@keyframes confirmClip": {
                    "0%": { clipPath: "inset(0 0 0 0)" },
                    "100%": { clipPath: "inset(0 100% 0 0)" },
                },
            } },
            React.createElement(PeekBox, { component: "span", sx: {
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    backgroundColor: theme.palette.error.main,
                } }, confirmLabel))));
};
